import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./ClientDashboardDemoComponents.module.scss";
import { ButtonGroup, Button } from "reactstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
const CustomTooltip = ({ active, payload, label, view }) => {
  if (!active || !payload || !payload.length) return null;
  const item = payload[0]?.payload || {};
  const kWh = payload[0]?.value;
  if (view === "month") {
    const start = new Date(item.date);
    const end = item.week_end ? new Date(item.week_end) : new Date(start.getTime() + 6 * 24 * 3600 * 1000);
    const startStr = start.toLocaleDateString(undefined, { month: "short", day: "numeric" });
    const endStr = end.toLocaleDateString(undefined, { month: "short", day: "numeric" });
    return (
      <div className="recharts-default-tooltip" style={{ background: "#fff", border: "1px solid #ccc", padding: 8 }}>
        <div>{`${startStr} - ${endStr}`}</div>
        <div>{`${kWh} kWh`}</div>
      </div>
    );
  }
  return (
    <div className="recharts-default-tooltip" style={{ background: "#fff", border: "1px solid #ccc", padding: 8 }}>
      <div>{label}</div>
      <div>{`${kWh} kWh`}</div>
    </div>
  );
};
function EnergyConsumptionChartDemo({ buildingId }) {
  const [view, setView] = useState("week");
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const id = buildingId;
      if (!id) return;
      const end = new Date();
      const start = new Date();
      if (view === "week") {
        start.setDate(end.getDate() - 6);
      } else if (view === "month") {
        start.setDate(end.getDate() - 27);
      }
      const qs = new URLSearchParams({
        interval: view,
        start: start.toISOString().slice(0, 10),
        end: end.toISOString().slice(0, 10),
      }).toString();
      const resp = await axios.get(`/energy/buildings/${id}?${qs}`);

      const data = resp.data.data || [];
      if (cancelled) return;
      if (view === "week") {
        setChartData(data.map((d) => ({ date: d.local_date, kWh: Number(d.cumulative_kwh_local_day) })));
      }
      // } else if (view === "month") {
      //   setChartData(data.map((d) => ({ date: d.week_start, week_end: d.week_end, kWh: Number(d.kwh) })));
      // }
    }
    load().catch(() => {});
    return () => { cancelled = true; };
  }, [view, buildingId]);

  return (
    <div>
      <div className={styles.InputRow}>
        <ButtonGroup className={styles.CompactButtonGroup}>
          <Button
            color={view === "week" ? "primary" : "secondary"}
            onClick={() => setView("week")}
          >
            Week
          </Button>
          {/* <Button
            color={view === "month" ? "primary" : "secondary"}
            onClick={() => setView("month")}
          >
            Month
          </Button> */}
        </ButtonGroup>
      </div>
      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 16, right: 16, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 1 }} />
            <YAxis tick={{ fontSize: 11 }} unit=" kWh" />
            <Tooltip content={<CustomTooltip view={view} />} />
            <Bar dataKey="kWh" fill="#007bff" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default EnergyConsumptionChartDemo;